import { LinkedHashSet2tkztfx86kyx2 as LinkedHashSet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashSet.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  Charsets_getInstancezrqwjk0yrlyw as Charsets_getInstance,
  get_name2f11g4r0d5pxp as get_name,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/charsets/Charset.js.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  $3l5vvh8yg0ier as $,
  orPromise1iucc2to2udt2 as orPromise,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Phases_getInstance1dciif7svdqxc as Phases_getInstance } from '../request/HttpRequestPipeline.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  isSuspendFunction153vlp5l2npj9 as isSuspendFunction,
  isInterface3d6p8outrmvmk as isInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { toList2zksu85ukrmi as toList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Maps.mjs';
import {
  sortedWith2csnbbb21k0lg as sortedWith,
  firstOrNull1982767dljvdy as firstOrNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { roundToInt1ue8x8yshtznx as roundToInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import {
  Text_getInstance2n0fbbag7eq4k as Text_getInstance,
  charset1dribv3ku48b1 as charset,
  withCharset27k3t3dvzhi4n as withCharset,
} from '../../../../../ktor-ktor-http/io/ktor/http/ContentTypes.mjs';
import { TextContent1rb6ftlpvl1d2 as TextContent } from '../../../../../ktor-ktor-http/io/ktor/http/content/TextContent.mjs';
import {
  charset3qqtyytkmxogi as charset_0,
  contentType2zzm38yxo3syt as contentType,
} from '../../../../../ktor-ktor-http/io/ktor/http/HttpMessageProperties.mjs';
import { readText27783kyxjxi1g as readText } from '../../../../../ktor-ktor-io/io/ktor/utils/io/core/Strings.nonJvm.mjs';
import { PrimitiveClasses_getInstance13wbaztpz3e2d as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { readRemainingh4lyqt5j6r85 as readRemaining } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannelOperations.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
import { createClientPluginjwpvufjows5r as createClientPlugin } from './api/CreatePluginUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_LOGGER() {
  _init_properties_HttpPlainText_kt__iy89z1();
  return LOGGER;
}
var LOGGER;
function get_HttpPlainText() {
  _init_properties_HttpPlainText_kt__iy89z1();
  return HttpPlainText;
}
var HttpPlainText;
var HttpPlainTextConfigClass;
function HttpPlainTextConfig() {
  if (HttpPlainTextConfigClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableSetOf' call
        tmp.charsets_1 = LinkedHashSet().new_kotlin_collections_LinkedHashSet_ahyf7j_k$();
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp_0.charsetQuality_1 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
        this.sendCharset_1 = null;
        this.responseCharsetFallback_1 = Charsets_getInstance().UTF_8__1;
      }
    }
    initMetadataForClass($, 'HttpPlainTextConfig', HttpPlainTextConfig);
    HttpPlainTextConfigClass = $;
  }
  return HttpPlainTextConfigClass;
}
function RenderRequestHook$install$slambda($handler) {
  return constructCallableReference(($this$intercept, content, $completion) => orPromise($completion, function *($completion) {
    var result = yield* $($handler($this$intercept.context_1, content, $completion), $completion);
    var tmp;
    if (!(result == null)) {
      yield* $this$intercept.proceedWith_i5skhv_k$(result, $completion);
      tmp = Unit_instance;
    }
    return Unit_instance;
  }), 2);
}
var RenderRequestHookClass;
function RenderRequestHook() {
  if (RenderRequestHookClass === VOID) {
    class $ {
      install_ridimw_k$(client, handler) {
        var tmp = Phases_getInstance().Render_1;
        client.requestPipeline_1.intercept_k21bv3_k$(tmp, RenderRequestHook$install$slambda(handler));
      }
      install_qsy0pg_k$(client, handler) {
        return this.install_ridimw_k$(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'RenderRequestHook');
    RenderRequestHookClass = $;
  }
  return RenderRequestHookClass;
}
var RenderRequestHook_instance;
function RenderRequestHook_getInstance() {
  return RenderRequestHook_instance;
}
function HttpPlainTextConfig$_init_$ref_isjudo() {
  return constructCallableReference(() => new (HttpPlainTextConfig())(), 0, 0, 217, '<init>');
}
function HttpPlainText$lambda($this$createClientPlugin) {
  _init_properties_HttpPlainText_kt__iy89z1();
  // Inline function 'kotlin.collections.sortedByDescending' call
  var this_0 = toList($this$createClientPlugin.pluginConfig_1.charsetQuality_1);
  // Inline function 'kotlin.comparisons.compareByDescending' call
  var tmp = HttpPlainText$lambda$lambda;
  var tmp$ret$1 = new (sam$kotlin_Comparator$0())(tmp);
  var withQuality = sortedWith(this_0, tmp$ret$1);
  var responseCharsetFallback = $this$createClientPlugin.pluginConfig_1.responseCharsetFallback_1;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = $this$createClientPlugin.pluginConfig_1.charsets_1;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    if (!$this$createClientPlugin.pluginConfig_1.charsetQuality_1.containsKey_aw81wo_k$(element)) {
      destination.add_utx5q5_k$(element);
    }
  }
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_0 = HttpPlainText$lambda$lambda_0;
  var tmp$ret$6 = new (sam$kotlin_Comparator$0())(tmp_0);
  var withoutQuality = sortedWith(destination, tmp$ret$6);
  var tmp_1;
  var tmp0_0 = $this$createClientPlugin.pluginConfig_1.charsets_1;
  var tmp$ret$7;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    var tmp_2;
    if (isInterface(tmp0_0, Collection())) {
      tmp_2 = tmp0_0.isEmpty_y1axqb_k$();
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp$ret$7 = false;
      break $l$block_0;
    }
    var _iterator__ex2g4s_0 = tmp0_0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
      var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
      if (!element_0.equals(Charsets_getInstance().UTF_8__1)) {
        tmp$ret$7 = true;
        break $l$block_0;
      }
    }
    tmp$ret$7 = false;
  }
  if (tmp$ret$7) {
    tmp_1 = true;
  } else {
    var tmp0_1 = $this$createClientPlugin.pluginConfig_1.charsetQuality_1.get_keys_wop4xp_k$();
    var tmp$ret$9;
    $l$block_2: {
      // Inline function 'kotlin.collections.any' call
      var tmp_3;
      if (isInterface(tmp0_1, Collection())) {
        tmp_3 = tmp0_1.isEmpty_y1axqb_k$();
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        tmp$ret$9 = false;
        break $l$block_2;
      }
      var _iterator__ex2g4s_1 = tmp0_1.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
        var element_1 = _iterator__ex2g4s_1.next_20eer_k$();
        if (!element_1.equals(Charsets_getInstance().UTF_8__1)) {
          tmp$ret$9 = true;
          break $l$block_2;
        }
      }
      tmp$ret$9 = false;
    }
    tmp_1 = tmp$ret$9;
  }
  var hasRegisteredCharsets = tmp_1;
  var tmp_4;
  if (hasRegisteredCharsets) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_1 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_2 = withoutQuality.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
      var element_2 = _iterator__ex2g4s_2.next_20eer_k$();
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(this_1) > 0) {
        this_1.append_22ad7x_k$(',');
      }
      this_1.append_22ad7x_k$(get_name(element_2));
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_3 = withQuality.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_3.hasNext_bitz1p_k$()) {
      var element_3 = _iterator__ex2g4s_3.next_20eer_k$();
      var charset = element_3.component1_7eebsc_k$();
      var quality = element_3.component2_7eebsb_k$();
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(this_1) > 0) {
        this_1.append_22ad7x_k$(',');
      }
      // Inline function 'kotlin.check' call
      if (!(0.0 <= quality ? quality <= 1.0 : false)) {
        throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Check failed.');
      }
      // Inline function 'kotlin.math.roundToInt' call
      var this_2 = 100 * quality;
      var truncatedQuality = roundToInt(this_2) / 100.0;
      this_1.append_22ad7x_k$(get_name(charset) + ';q=' + truncatedQuality);
    }
    tmp_4 = this_1.toString();
  } else {
    tmp_4 = null;
  }
  var acceptCharsetHeader = tmp_4;
  var tmp0_elvis_lhs = $this$createClientPlugin.pluginConfig_1.sendCharset_1;
  var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? firstOrNull(withoutQuality) : tmp0_elvis_lhs;
  var tmp_5;
  if (tmp1_elvis_lhs == null) {
    var tmp2_safe_receiver = firstOrNull(withQuality);
    tmp_5 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.first_1;
  } else {
    tmp_5 = tmp1_elvis_lhs;
  }
  var tmp3_elvis_lhs = tmp_5;
  var requestCharset = tmp3_elvis_lhs == null ? Charsets_getInstance().UTF_8__1 : tmp3_elvis_lhs;
  var tmp_6 = RenderRequestHook_instance;
  $this$createClientPlugin.on_z1oiz_k$(tmp_6, HttpPlainText$lambda$slambda(acceptCharsetHeader, requestCharset));
  $this$createClientPlugin.transformResponseBody_ee7rr5_k$(HttpPlainText$lambda$slambda_0(responseCharsetFallback));
  return Unit_instance;
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.function_1 = function_0;
      }
      compare_bczr_k$(a, b) {
        return this.function_1(a, b);
      }
      compare(a, b) {
        return this.compare_bczr_k$(a, b);
      }
      getFunctionDelegate_jtodtf_k$() {
        return this.function_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.getFunctionDelegate_jtodtf_k$(), other.getFunctionDelegate_jtodtf_k$());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.getFunctionDelegate_jtodtf_k$());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function HttpPlainText$lambda$lambda(a, b) {
  _init_properties_HttpPlainText_kt__iy89z1();
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = b.second_1;
  var tmp$ret$2 = a.second_1;
  return compareValues(tmp, tmp$ret$2);
}
function HttpPlainText$lambda$lambda_0(a, b) {
  _init_properties_HttpPlainText_kt__iy89z1();
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = get_name(a);
  var tmp$ret$2 = get_name(b);
  return compareValues(tmp, tmp$ret$2);
}
function invoke$wrapContent(requestCharset, request, content, requestContentType) {
  var contentType = requestContentType == null ? Text_getInstance().Plain_1 : requestContentType;
  var tmp2_elvis_lhs = requestContentType == null ? null : charset(requestContentType);
  var charset_0 = tmp2_elvis_lhs == null ? requestCharset : tmp2_elvis_lhs;
  get_LOGGER().trace_fti9bv_k$('Sending request body to ' + request.url_1.toString() + ' as text/plain with charset ' + charset_0.toString());
  return new (TextContent())(content, withCharset(contentType, charset_0));
}
function invoke$read(responseCharsetFallback, call, body) {
  var tmp0_elvis_lhs = charset_0(call.get_response_xlk07e_k$());
  var actualCharset = tmp0_elvis_lhs == null ? responseCharsetFallback : tmp0_elvis_lhs;
  get_LOGGER().trace_fti9bv_k$('Reading response body for ' + call.get_request_jdwg4m_k$().get_url_18iuii_k$().toString() + ' as String with charset ' + actualCharset.toString());
  return readText(body, actualCharset);
}
function invoke$addAcceptCharsetHeader(_this__u8e3s4, value) {
  if (value == null || !(_this__u8e3s4.headers_1.get_6bo4tg_k$('Accept-Charset') == null))
    return Unit_instance;
  get_LOGGER().trace_fti9bv_k$('Adding Accept-Charset=' + value + ' to ' + _this__u8e3s4.url_1.toString());
  _this__u8e3s4.headers_1.set_j87cuq_k$('Accept-Charset', value);
}
function HttpPlainText$lambda$slambda($acceptCharsetHeader, $requestCharset) {
  return constructCallableReference((request, content, $completion) => orPromise($completion, function *($completion) {
    invoke$addAcceptCharsetHeader(request, $acceptCharsetHeader);
    var tmp;
    if (!(typeof content === 'string')) {
      return null;
    }
    var contentType_0 = contentType(request);
    var tmp_0;
    if (!(contentType_0 == null) && !(contentType_0.contentType_1 === Text_getInstance().Plain_1.contentType_1)) {
      return null;
    }
    return invoke$wrapContent($requestCharset, request, content, contentType_0);
  }), 2);
}
function HttpPlainText$lambda$slambda_0($responseCharsetFallback) {
  return constructCallableReference(($this$transformResponseBody, response, content, requestedType, $completion) => orPromise($completion, function *($completion) {
    var tmp;
    if (!requestedType.type_1.equals(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$())) {
      return null;
    }
    var bodyBytes = yield* readRemaining(content, $completion);
    return invoke$read($responseCharsetFallback, response.get_call_wojxrb_k$(), bodyBytes);
  }), 4);
}
var properties_initialized_HttpPlainText_kt_2nx4ox;
function _init_properties_HttpPlainText_kt__iy89z1() {
  if (!properties_initialized_HttpPlainText_kt_2nx4ox) {
    properties_initialized_HttpPlainText_kt_2nx4ox = true;
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.HttpPlainText');
    var tmp = HttpPlainTextConfig$_init_$ref_isjudo();
    HttpPlainText = createClientPlugin('HttpPlainText', tmp, HttpPlainText$lambda);
  }
}
//region block: init
RenderRequestHook_instance = new (RenderRequestHook())();
//endregion
//region block: exports
export {
  get_HttpPlainText as get_HttpPlainText2hd9sygnz4kij,
};
//endregion

//# sourceMappingURL=HttpPlainText.mjs.map
